import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { SIDEBAR_ITEMS, AuthStore, UiStore, UploadStore, AUTH_USER_PROPERTY } from '@shared';
import { httpLoaderFactory } from './translate-loader.factory';
import { routes } from './app.routes';

import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { AuthInterceptor, ErrorInterceptor, SHARED_API_CONFIG, SharedApiConfig } from '@shared';
import { provideToastr } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GOOGLE_MAPS_KEY } from '@shared';
import { ADMIN_MENU_ITEMS } from './menu';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideStore(),
    provideState(UiStore.config),
    provideState(AuthStore.config),
    provideState(UploadStore.config),
    provideEffects(...AuthStore.effects, ...UploadStore.effects), // Registers UI, Auth and Upload effects
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideAnimations(),
    provideToastr(),
    { provide: SIDEBAR_ITEMS, useValue: ADMIN_MENU_ITEMS },
    { provide: GOOGLE_MAPS_KEY, useValue: environment.googleMapsApiKey },
    { provide: AUTH_USER_PROPERTY, useValue: 'userAdmin' },

    // HTTP Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // Provide Shared API Configuration
    {
      provide: SHARED_API_CONFIG,
      useValue: {
        apiBaseUrl: environment.apiUrl,
        endpoints: environment.endpoints,
      } as SharedApiConfig,
    },
  ],
};
